export const backendURL = "https://spotify-for-artists.onrender.com"
